import { forwardRef, useEffect, useRef } from "react";

const AutogrowTextarea = forwardRef((props: any, outsideTextareaRef: any) => {
  const {
    minHeight = 60,
    value,
    onChange,
    onKeyDown,
    autoFocus,
    inlinemode,
    readOnly,
    placeholder,
    className,
  } = props;

  const localTextareaRef = useRef(null);
  const autogrowTextareaRef = outsideTextareaRef || localTextareaRef;

  useEffect(() => {
    if (autogrowTextareaRef.current) {
      // We need to reset the height momentarily to get the correct scrollHeight for the textarea
      autogrowTextareaRef.current.style.height = "0px";
      let scrollHeight = autogrowTextareaRef.current.scrollHeight;

      if (scrollHeight < minHeight) scrollHeight = minHeight;

      // We then set the height directly, outside of the render loop
      // Trying to set this with state or a ref will produce an incorrect value.
      autogrowTextareaRef.current.style.height =
        scrollHeight + (inlinemode ? 0 : 2) + "px";
    }
  }, [autogrowTextareaRef, value]);

  return (
    <textarea
      className={
        inlinemode
          ? "block m-0 p-0 w-full text-sm bg-secondary placeholder-gray-400 text-[length:inherit] leading-[inherit] focus:ring-blue outline-none resize-none"
          : `block px-3.5 py-3 w-full text-base rounded-lg border border-gray-200 bg-white text-gray-900 placeholder:text-gray-400 hover:border-gray-300 focus:border-primary focus:ring-2 focus:ring-primary/20 focus:outline-none resize-none shadow-sm transition-all duration-150${className ? ` ${className}` : ""}`
      }
      rows={1}
      cols={50}
      ref={autogrowTextareaRef}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      autoFocus={autoFocus}
      readOnly={readOnly}
      placeholder={placeholder}
    />
  );
});

export default AutogrowTextarea;
